import $ from 'jquery';

export default function initAccordion() {
	const $toggles = $('.accordion-item .accordion-item__toggle');
	if (!$toggles.length) {
		return;
	}

	$toggles.off('click').on('click', function (e) {
		e.preventDefault();
		e.stopPropagation();
		const $toggle = $(this);
		const $item = $toggle.closest('.accordion-item');
		const $panel = $item.find('.accordion-item__panel').first();

		if ($toggle.attr('aria-expanded') === 'true') {
			$item.removeClass('accordion-item--open');
			$toggle.attr('aria-expanded', 'false');
			$panel.slideUp(250);
			$panel.prop('hidden', true);
		} else {
			$item.addClass('accordion-item--open');
			$toggle.attr('aria-expanded', 'true');
			$panel.prop('hidden', false);
			$panel.slideDown(250);
		}
	});
}
